require('./lbaPagingGrid.scss');

const $inject = [];

const lbaPagingGrid = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '='
    },
    bindToController: true,
    controller: 'lbaPagingGridCtrl',
    controllerAs: 'vm',
    template: require('./lbaPagingGrid.html')
  }
};

lbaPagingGrid.$inject = $inject;

export default lbaPagingGrid;



// WEBPACK FOOTER //
// ./src/components/lbaPagingGrid/lbaPagingGridDir.js